"use client";

import { useState } from "react";

import {
    CaretLeftIcon,
    CaretRightIcon,
} from "@phosphor-icons/react/ssr";

import {
    Carousel,
    CarouselApi,
    CarouselContent,
    CarouselItem,
} from "~/components/ui/carousel";

import usePrevNextButtons from "~/componentsND/carousel/usePrevNextButtons";
import Paragraph from "~/componentsDS/Typography/Paragraph";

import { cn } from "~/lib/utils";
import Autoplay from "embla-carousel-autoplay";

type Props = {
    className?: string;
};

const autoplay = Autoplay({ playOnInit: true, delay: 4000 });

const messages = [
    "Prescribed by licensed physician",
    "Doctor visits included",
    "HSA/FSA eligible",
    "Money Back Guarantee on eligible products",
];

export const PromoBar = ({ className }: Props) => {
    const [emblaApi, setApi] = useState<CarouselApi>();

    const {
        prevBtnDisabled,
        nextBtnDisabled,
        onPrevButtonClick,
        onNextButtonClick,
    } = usePrevNextButtons(emblaApi);

    return (
        <div className={cn("bg-primary500 text-pureWhite text-center p-[10px] flex gap-2 justify-center", className)}>
            <button disabled={prevBtnDisabled} onClick={onPrevButtonClick}>
                <CaretLeftIcon size={20} />
            </button>

            <Carousel setApi={setApi} plugins={[autoplay]} className="max-w-[360px]">
                <CarouselContent>
                    {messages.map((message, index) => {
                        return (
                            <CarouselItem key={index}>
                                <Paragraph size="sm" sizes={{ md: "md" }} className="leading-5 flex justify-center gap-2">{message}</Paragraph>
                            </CarouselItem>
                        );
                    })}
                </CarouselContent>
            </Carousel>

            <button disabled={nextBtnDisabled} onClick={onNextButtonClick}>
                <CaretRightIcon size={20} />
            </button>
        </div>
    );
};

export default PromoBar;
